var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$style['mds-search-results__section']},[_c('mds-section',{attrs:{"border":"primary","title":_vm.title,"size":8,"bold":""},scopedSlots:_vm._u([{key:"mds-section-actions",fn:function(){return [_vm._t("mds-search-results-section-actions")]},proxy:true}],null,true)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }